function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50 24.9965C49.9993 20.0521 48.5325 15.219 45.785 11.1082C43.0376 6.99742 39.1329 3.79365 34.5646 1.90199C29.9964 0.0103364 24.9699 -0.48425 20.1206 0.480773C15.2713 1.4458 10.817 3.82709 7.32108 7.32354C3.82512 10.82 1.44444 15.2746 0.480094 20.124C-0.484254 24.9734 0.0110323 29.9999 1.90333 34.5679C3.79562 39.1358 6.99993 43.0401 11.1111 45.787C15.2222 48.5338 20.0556 50 25 50C28.2833 50 31.5345 49.3532 34.5679 48.0966C37.6012 46.84 40.3574 44.9982 42.6789 42.6764C45.0004 40.3546 46.8418 37.5982 48.098 34.5646C49.3541 31.5311 50.0004 28.2798 50 24.9965Z",
  fill: "#D40C18"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3919 15.7777H18.6116C15.193 15.7777 12.4217 18.5491 12.4217 21.9677V28.0393C12.4217 31.4579 15.193 34.2292 18.6116 34.2292H31.3919C34.8105 34.2292 37.5818 31.4579 37.5818 28.0393V21.9677C37.5818 18.5491 34.8105 15.7777 31.3919 15.7777Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1142 25.0662L21.7101 29.592C21.6476 29.6255 21.5777 29.6427 21.5069 29.642C21.436 29.6413 21.3665 29.6227 21.3047 29.588C21.2429 29.5533 21.1909 29.5036 21.1534 29.4434C21.1159 29.3832 21.0943 29.3146 21.0904 29.2438V20.1121C21.0905 20.0391 21.1096 19.9673 21.1458 19.9039C21.182 19.8405 21.2341 19.7875 21.297 19.7503C21.3598 19.7131 21.4313 19.6929 21.5043 19.6916C21.5773 19.6903 21.6494 19.7081 21.7135 19.7431L30.1142 24.3176C30.1828 24.3531 30.2404 24.4068 30.2806 24.4728C30.3208 24.5388 30.3421 24.6146 30.3421 24.6919C30.3421 24.7692 30.3208 24.845 30.2806 24.911C30.2404 24.977 30.1828 25.0307 30.1142 25.0662Z",
  fill: "#DB0C0B"
});

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.8aef9a86.svg";
export { ForwardRef as ReactComponent };